module.exports = __webpack_public_path__ + "img/card-2.0b340c11.png";